import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-image-mdoal',
  templateUrl: './image-mdoal.component.html',
  styleUrls: ['./image-mdoal.component.scss']
})
export class ImageMdoalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

}
